import React, { useContext } from 'react'
import { UserContext } from '../App/UserContext'
import { RecentlyViewedCard } from '@plm-core/recently-viewed'
import {
  Grid,
  Caption,
  DateFormatter,
  Heading,
} from '@design-systems/canvas-ui'
import styles from './Dashboard.module.css'
import { recentlyViewedEntityConfig } from '../config/RecentlyViewedConfig'
import { useEnv } from '@praxis/component-runtime-env'
import { envConfigs, ReactAppEnv } from 'apiConfig'
import { PageLayout } from '@plm-core/utils'
import dashboardBgDark from '../assets/dashboard_background_dark.png'
import dashboardBgLight from '../assets/dashboard_background_light.png'

const getGreeting = (): string => {
  const hour = new Date().getHours()
  if (hour < 12) return 'Good morning, '
  if (hour < 18) return 'Good afternoon, '
  return 'Good evening, '
}

const Dashboard = () => {
  const { sparkUser, isDark } = useContext(UserContext)
  const { environment }: { environment: ReactAppEnv } = useEnv()

  const user = sparkUser as any
  const firstName = user?.firstName ?? 'User'

  const heroBackground = `url(${isDark ? dashboardBgDark : dashboardBgLight})`

  return (
    <div className={styles.hero} style={{ backgroundImage: heroBackground }}>
      <PageLayout>
        <Grid.Container direction="column" justify="center">
          <Grid.Item className="hc8-mt-20x hc8-mh-6x">
            <Grid.Container>
              <Grid.Item size={{ xs: 12 }}>
                <Caption
                  className="hc8-mb-2x"
                  style={{ color: 'var(--color-text-always-white)' }}
                >
                  <DateFormatter
                    date={new Date().toISOString()}
                    format="dddd, MMM D, YYYY"
                  />
                </Caption>
                <Heading size={1} className={`${styles.greeting} hc8-pb-2x`}>
                  {`${getGreeting()}${firstName}`}
                </Heading>
              </Grid.Item>
            </Grid.Container>
          </Grid.Item>
          <Grid.Item>
            <Grid.Container>
              <Grid.Item size={{ xs: 12 }}>
                <RecentlyViewedCard
                  config={recentlyViewedEntityConfig}
                  xApiKey={envConfigs[environment]?.xApiKey}
                />
              </Grid.Item>
            </Grid.Container>
          </Grid.Item>
        </Grid.Container>
      </PageLayout>
    </div>
  )
}

export default Dashboard
